import { reportsService } from '@/services';
import type { FinancialSummary, GetReceiptsParams } from '@/services';
import { useQuery } from '@tanstack/react-query';
import { toReceiptsApiParams } from './use-receipts.hook';

const EMPTY_SUMMARY: FinancialSummary = {
  totalValue: 0,
  advisoryCommission: 0,
  brokerCommission: 0,
};

/**
 * Cards "Próximo Pagamento" (Valor Total, Comissão Assessoria, Comissão
 * Corretor). Endpoint separado da listagem, então a paginação não recalcula a
 * agregação — a queryKey usa só os filtros (sem page/pageSize/sort).
 */
export function useReceiptsSummary(filters: GetReceiptsParams = {}) {
  const apiParams = toReceiptsApiParams(filters);
  // Remove paginação/ordenação da chave de cache.
  const cacheKey = {
    ...apiParams,
    page: undefined,
    pageSize: undefined,
    sortField: undefined,
    sortType: undefined,
  };

  return useQuery({
    queryKey: ['financial-receipts-summary', cacheKey],
    queryFn: async (): Promise<FinancialSummary> => {
      const response = await reportsService.getReceiptsSummary(apiParams);
      if (!response.success || !response.data) {
        return EMPTY_SUMMARY;
      }
      const { total, advisory, broker } = response.data;
      // Corretor: a API não envia `total`/`advisory` — ficam `undefined`.
      return {
        totalValue: total?.amount,
        advisoryCommission: advisory?.amount,
        brokerCommission: broker?.amount ?? 0,
      };
    },
    staleTime: 1000 * 60 * 5,
  });
}
